import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { MojoNotificationRequestWidgetComponent } from './containers/notification-widget/mojo-notification-request-widget.component';
import { MojoNotificationWidgetComponent } from './containers/notification-widget/mojo-notification-widget.component';
import { MojoNotificationSendDialogComponent } from './components/notification-send-dialog/mojo-notification-widget-send-dialog.component';
import { MojoNotificationRecipientsDialogComponent } from './components/notification-recipients-dialog/mojo-notification-recipients-dialog.component';
import { FormLayoutModule } from '../form-layout/form-layout.module';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NoticeBoardNotificationDeleteService } from "./services/noticeboardnotification-delete.service";
import {
  MojoNotificationAttachmentsDialogComponent
} from "@feature/_app_modules/mojo-notification-widget/components/notification-attachments-dialog/mojo-notification-attachments-dialog.component";
import { MatListModule } from '@angular/material/list';

@NgModule({
  declarations: [
    MojoNotificationRequestWidgetComponent,
    MojoNotificationWidgetComponent,
    MojoNotificationSendDialogComponent,
    MojoNotificationRecipientsDialogComponent,
    MojoNotificationAttachmentsDialogComponent
    ],
  exports: [
    MojoNotificationRequestWidgetComponent,
    MojoNotificationWidgetComponent
    ],
  imports: [
    CommonModule,
    SharedModule,
    FormLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MatListModule
  ],
  providers: [NoticeBoardNotificationDeleteService]
})

export class MojoNotificationWidgetModule { }
